// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ZIF7","input":"styles_input__2tAGZ"};